import { useContext } from 'react';
import { GlobalLoaderContext } from '../contexts/GlobalLoader';
import { GlobalLoaderContextValue } from '../contexts/GlobalLoader/types';

const useGlobalLoaderContext = (): GlobalLoaderContextValue =>
  useContext(GlobalLoaderContext);

export default useGlobalLoaderContext;
